import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { MessageBanner } from '@folio/stripes/components';
var STATE_MESSAGES = {
    PENDING_REVIEW: 'ui-czna-authorities.proposals.targetRecord.state.PENDING_REVIEW',
    PENDING_NATIONAL_REVIEW: 'ui-czna-authorities.proposals.targetRecord.state.PENDING_NATIONAL_REVIEW',
    CHANGES_REQUESTED: 'ui-czna-authorities.proposals.targetRecord.state.CHANGES_REQUESTED',
};
var isAwaited = function (reviewStatus) {
    return !!reviewStatus && reviewStatus in STATE_MESSAGES;
};
var recordUrl = function (id) { return "/czna-authorities/authorities/".concat(id); };
/**
 * CZNA-1525 — a change proposal of a record that is not approved yet (local review, NK
 * review, returned) or that NK has cancelled. Says which record, in which state, and — while
 * the record waits — that the change is processed only after the record's approval. A
 * warning, never a gate: saving the proposal stays possible.
 *
 * <p>Whether the change may be APPROVED is not decided here: that is `approvalBlock`, the
 * backend's answer (a returned record does not block its own creator's correction,
 * CZNA-1054), and its reason is printed as the server wrote it.
 *
 * <p>Renders nothing for an approved, active record without a block.
 */
var TargetRecordStateBanner = function (_a) {
    var _b;
    var record = _a.record, approvalBlock = _a.approvalBlock;
    var cancelled = record.status === 'MERGED' || record.status === 'DELETED';
    var awaited = !cancelled && isAwaited(record.reviewStatus) ? record.reviewStatus : null;
    if (!cancelled && !awaited && !approvalBlock)
        return null;
    var recordLink = React.createElement(Link, { to: recordUrl(record.id) }, record.authorityId);
    return (React.createElement(MessageBanner, { type: "warning" },
        React.createElement("div", { "data-test-target-record-state": cancelled ? 'CANCELLED' : (awaited !== null && awaited !== void 0 ? awaited : 'APPROVED') },
            React.createElement("div", null,
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.targetRecord.label" })),
                ' ',
                recordLink),
            awaited && (React.createElement("div", null,
                React.createElement(FormattedMessage, { id: STATE_MESSAGES[awaited] }),
                ' ',
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.targetRecord.processedAfterApproval" }))),
            awaited === 'CHANGES_REQUESTED' && record.reviewComment && (React.createElement("div", { "data-test-target-record-nk-question": true },
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.targetRecord.nkQuestion" })),
                ': ',
                React.createElement("span", { style: { whiteSpace: 'pre-wrap' } }, record.reviewComment))),
            cancelled && (React.createElement("div", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.targetRecord.cancelled" }),
                record.successorId && (React.createElement(React.Fragment, null,
                    ' ',
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.targetRecord.successor" }),
                    ' ',
                    React.createElement(Link, { to: recordUrl(record.successorId), "data-test-target-record-successor": true }, (_b = record.successorAuthorityId) !== null && _b !== void 0 ? _b : record.successorId))))),
            approvalBlock && (React.createElement("div", { "data-test-proposal-approval-block": approvalBlock.code, style: { marginTop: '8px' } },
                React.createElement("strong", null, approvalBlock.message))))));
};
export default TargetRecordStateBanner;
